<div class="result-list-container">
  <div *ngIf="results?.length===0" class="empty-state">
    <ng-container *ngFor="let line of placeholder">
      {{ line }}<br>
    </ng-container>
  </div>
  <div class="domain-item" *ngFor="let result of results">
    <div class="domain-and-add-container">
      <button class="icon-button" (click)="onAdd(result)">
        <img [src]="'svg/plus.svg' | assetVersion">
      </button>
      <div class="domain-text" title="{{ result.value }}">{{ result.value }}</div>
    </div>
    <button class="icon-button" *ngIf="resultClickCallback" (click)="resultClickCallback(result)">
      <img [src]="'svg/redirect.svg' | assetVersion">
    </button>
  </div>
  <app-loader *ngIf="isLoading"></app-loader>
</div>